import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from '@bordrio/ui-components';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Alert, Button, Card } from '@src/components';
import { useLogOut } from '@src/hooks/useLogOut';
import { formatAndReportAuthError } from '@src/services/error-formatter';

function Auth0CallbackPage(): JSX.Element {
  const navigate = useNavigate();
  const logOut = useLogOut();
  const { t } = useTranslation();

  const { handleRedirectCallback } = useAuth0();
  const [error, setError] = useState<string | null>(null);
  // https://github.com/auth0/auth0-react/pull/355
  const didHandleRedirect = useRef(false);

  useEffect(() => {
    if (didHandleRedirect.current) {
      return;
    }
    didHandleRedirect.current = true;
    handleRedirectCallback()
      .then(({ appState }: { appState?: { returnTo?: string } }) => {
        void navigate(appState?.returnTo ?? '/', { replace: true });
      })
      .catch((err) => {
        setError(formatAndReportAuthError(err));
      });
  }, [handleRedirectCallback, navigate]);

  return (
    <div className="flex h-full items-center justify-center bg-gray-100">
      {error ? (
        <Card className="space-y-4 p-4">
          <Alert type="error">{error}</Alert>
          <Button onClick={logOut}>
            {t('buttons.try_again', 'Try Again')}
          </Button>
        </Card>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default Auth0CallbackPage;
